import React from 'react';
import ReactDOM from 'react-dom';
// Needed for onTouchTap
import injectTapEventPlugin from 'react-tap-event-plugin';

import * as SocketIO from './common/SocketIO.js';
import Router from './router.js';

injectTapEventPlugin();
SocketIO.init();

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    React.createElement(Router),
    document.getElementById('sqs')
  );
});


// WEBPACK FOOTER //
// client/index.js